import {styled, ToggleButtonGroup as MuiToggleButtonGroup, toggleButtonGroupClasses} from "@mui/material";

const ToggleButtonGroup = styled(MuiToggleButtonGroup)(({theme}) => {
  return {
    justifyContent: 'center',
    width: '100%',
    // backgroundColor: theme.palette.background.default,
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      flex: 1,
      border: 'none',
      borderRadius: 'unset',
      backgroundColor: 'transparent',
      borderTop: `1px solid ${theme.palette.borderColor}`,
      borderLeft: `1px solid ${theme.palette.borderColor}`,
      borderBottom: `1px solid ${theme.palette.borderColor}`,
      padding: '3px 20px',
      [`& .MuiTypography-root`]: {
        fontSize: '12px',
      }
    },
    '& .MuiBox-root': {
      // borderRadius: '36px',
      // backgroundColor: theme.palette.background.default,
    },
    [`& .${toggleButtonGroupClasses.firstButton}`]: {
      borderTopLeftRadius: 36,
      borderBottomLeftRadius: 36,
      // backgroundColor: theme.palette.background.default,
      // borderRadius: '36px',
      // borderBottomLeftRadius: '36px',
    },
    [`& .${toggleButtonGroupClasses.lastButton}`]: {
      borderTopRightRadius: 36,
      borderBottomRightRadius: 36,
      borderRight: `1px solid ${theme.palette.borderColor}`,
    },
    // [`& .${toggleButtonGroupClasses.selected}`]: {
    //     borderRight: `1px solid ${theme.palette.borderColor}`,
    //     // backgroundColor: theme.palette.background.paper,
    // },
  }
})

export {ToggleButtonGroup}